export const CART_CONFIRM         = 'CART_CONFIRM'
export const ADD_TO_CART          = 'ADD_TO_CART'
export const ADD_TO_TMP_CART      = 'ADD_TO_TMP_CART'
export const REMOVE_FROM_CART     = 'REMOVE_FROM_CART'
export const REMOVE_FROM_TMP_CART = 'REMOVE_FROM_TMP_CART'
export const RESET_CART           = 'RESET_CART'
export const RESET_TMP_CART       = 'RESET_TMP_CART'
export const CHANGE_ITM_QTY       = 'CHANGE_ITM_QTY'
export const SAVE_CART            = 'SAVE_CART'
export const SHOW_CART            = 'SHOW_CART'
export const HIDE_CART            = 'HIDE_CART'
export const SET_CART_VISIBILITY  = 'SET_CART_VISIBILITY'
export const UPDATE_PRICE         = 'UPDATE_PRICE'
export const OPEN_DIALOG          = 'OPEN_DIALOG'
export const CLOSE_DIALOG         = 'CLOSE_DIALOG'
export const SET_CART_CUSTOMER    = 'SET_CART_CUSTOMER'
export const SET_CART_USER_TOKEN  = 'SET_CART_USER_TOKEN'
export const RESET_CART_ITEMS     = 'RESET_CART_ITEMS'
export const STORE_OLD_CART       = 'STORE_OLD_CART'
export const RECOVER_OLD_CART     = 'RECOVER_OLD_CART'
export const UPDATE_TOTAL_QTY     = 'UPDATE_TOTAL_QTY'
export const RESET_OLD_CART       = 'RESET_OLD_CART'
export const UPDATE_CART          = 'UPDATE_CART'
export const COMPARE_OLD_CART     = 'COMPARE_OLD_CART'